import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Tạo đơn (RequestDrawer.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'rd.kLeave': 'Nghỉ phép',
  'rd.kOt': 'Tăng ca',
  'rd.kTrip': 'Công tác',
  'rd.kFix': 'Giải trình công',
  'rd.full': 'Cả ngày',
  'rd.am': 'Sáng',
  'rd.pm': 'Chiều',
  'rd.hr': 'Theo giờ',
  'rd.sent': 'Đã gửi {id} · chờ {seat}',
  'rd.title': 'Tạo đơn',
  'rd.cancel': 'Huỷ',
  'rd.send': 'Gửi đơn',
  'rd.type': 'Loại đơn',
  'rd.leaveType': 'Loại nghỉ',
  'rd.fixDay': 'Ngày cần giải trình',
  'rd.otDay': 'Ngày tăng ca',
  'rd.from': 'Từ ngày',
  'rd.to': 'Đến ngày',
  'rd.window': 'Khung giờ',
  'rd.content': 'Nội dung',
  'rd.half': 'Buổi',
  'rd.place': 'Nơi đến',
  'rd.explain': 'Giải trình',
  'rd.reason': 'Lý do',
  'rd.phOt': 'Hỗ trợ khách chốt SI trước cut-off',
  'rd.phFix': 'Ra khỏi VP lúc 17:40, quên bấm chấm ra',
  'rd.phLeave': 'Việc gia đình',
  'rd.handover': 'Người nhận bàn giao',
  'rd.attached': 'Đã đính kèm giấy khám',
  'rd.attachReq': 'Đính kèm giấy khám (bắt buộc)',
  'rd.attachOpt': 'Đính kèm tệp (không bắt buộc)',
  'rd.preview': 'Xem trước',
  'rd.hours': 'Số giờ',
  'rd.hoursU': 'giờ',
  'rd.byCal': 'Theo lịch làm việc công ty',
  'rd.dayType': 'Loại ngày',
  'rd.holiday': 'Ngày lễ',
  'rd.workday': 'Ngày làm việc',
  'rd.weekend': 'Ngày nghỉ tuần',
  'rd.code': 'Mã đơn',
  'rd.date': 'Ngày',
  'rd.byCal2': 'Tính bằng lịch làm việc công ty',
  'rd.due': 'Hạn giải trình',
  'rd.skipped': ' · {n} ngày nghỉ đã bỏ',
  'rd.days': 'Số ngày',
  'rd.leftAfter': 'Phép còn sau đơn',
  'rd.noDeduct': 'không trừ phép',
  'rd.skipTitle': 'CN / lễ trong khoảng',
  'rd.skip': 'Ngày nghỉ bỏ qua',
  'rd.route': 'Đường duyệt',
});
addMessages('en', {
  'rd.kLeave': 'Leave',
  'rd.kOt': 'Overtime',
  'rd.kTrip': 'Business trip',
  'rd.kFix': 'Attendance explanation',
  'rd.full': 'Full day',
  'rd.am': 'Morning',
  'rd.pm': 'Afternoon',
  'rd.hr': 'By the hour',
  'rd.sent': 'Sent {id} · waiting {seat}',
  'rd.title': 'New request',
  'rd.cancel': 'Cancel',
  'rd.send': 'Send request',
  'rd.type': 'Request type',
  'rd.leaveType': 'Leave type',
  'rd.fixDay': 'Day to explain',
  'rd.otDay': 'Overtime day',
  'rd.from': 'From',
  'rd.to': 'To',
  'rd.window': 'Time window',
  'rd.content': 'Content',
  'rd.half': 'Session',
  'rd.place': 'Destination',
  'rd.explain': 'Explanation',
  'rd.reason': 'Reason',
  'rd.phOt': 'Supporting a customer to finalise SI before cut-off',
  'rd.phFix': 'Left the office at 17:40, forgot to clock out',
  'rd.phLeave': 'Family matter',
  'rd.handover': 'Handover recipient',
  'rd.attached': 'Medical certificate attached',
  'rd.attachReq': 'Attach medical certificate (required)',
  'rd.attachOpt': 'Attach a file (optional)',
  'rd.preview': 'Preview',
  'rd.hours': 'Hours',
  'rd.hoursU': 'h',
  'rd.byCal': 'Per company work calendar',
  'rd.dayType': 'Day type',
  'rd.holiday': 'Public holiday',
  'rd.workday': 'Working day',
  'rd.weekend': 'Weekly day off',
  'rd.code': 'Request code',
  'rd.date': 'Date',
  'rd.byCal2': 'Computed by the company work calendar',
  'rd.due': 'Explanation due',
  'rd.skipped': ' · {n} days off skipped',
  'rd.days': 'Days',
  'rd.leftAfter': 'Leave left after request',
  'rd.noDeduct': 'no leave deducted',
  'rd.skipTitle': 'Sundays / holidays in range',
  'rd.skip': 'Days off skipped',
  'rd.route': 'Approval route',
});
